import { LOCALES } from '@marketplace/i18n';

export const cardI18n = {
  [LOCALES.ENG]: {
    developer_card_button_capitalized: 'Learn More',
  }
};
